export interface IAppConfiguration {
  culture: string;
  currencyCode: string;
  xsrf: string;
  isAuthenticated: boolean;
  useBeforeVat: boolean;
  recaptchaSiteKey: string;
}

type AppWindow = Window &
  typeof globalThis & {
    netbiz: {
      configuration: IAppConfiguration;
    };
  };

export function getAppConfiguration(): IAppConfiguration {
  return (window as AppWindow).netbiz.configuration;
}

export function initAppConfiguration(): void {
  const html = document.querySelector('html') as HTMLElement;
  const configurationJson = html.dataset.reactConfiguration;
  const configuration = JSON.parse(configurationJson!) as IAppConfiguration;
  html.removeAttribute('data-react-configuration');

  const w = window as AppWindow;
  if (!('netbiz' in w) || !('configuration' in w.netbiz))
    w.netbiz = {
      configuration,
    };
}
